/**
 * @generated SignedSource<<792d613a4b421be6921e8cd15b47dd7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamWhitelistUsersMutation$variables = {
  teamId: string;
  whitelistUserIds: ReadonlyArray<string>;
};
export type TeamWhitelistUsersMutation$data = {
  readonly team: {
    readonly updateWhitelistUserIds: {
      readonly whitelistUsers: ReadonlyArray<{
        readonly user: {
          readonly id: string;
        };
      }>;
    };
  };
};
export type TeamWhitelistUsersMutation = {
  response: TeamWhitelistUsersMutation$data;
  variables: TeamWhitelistUsersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "whitelistUserIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "newWhitelistUserIds",
    "variableName": "whitelistUserIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamWhitelistUsersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamMutation",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "updateWhitelistUserIds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreUser",
                "kind": "LinkedField",
                "name": "whitelistUsers",
                "plural": true,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamWhitelistUsersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamMutation",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "updateWhitelistUserIds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreUser",
                "kind": "LinkedField",
                "name": "whitelistUsers",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d5b233a1b248a6d79afb987612442f87",
    "id": null,
    "metadata": {},
    "name": "TeamWhitelistUsersMutation",
    "operationKind": "mutation",
    "text": "mutation TeamWhitelistUsersMutation(\n  $teamId: ID!\n  $whitelistUserIds: [ID!]!\n) {\n  team(id: $teamId) {\n    updateWhitelistUserIds(newWhitelistUserIds: $whitelistUserIds) {\n      whitelistUsers {\n        user {\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a8f6ea3b142f8982bc6fda477c21b4c";

export default node;
